module.exports = __webpack_public_path__ + "img/bhjhhse.a384e670.png";